
export enum AiModel {
    Gpt5Mini = "gpt-5-mini",
    Gpt52 = "gpt-5.2",
    Gpt54Mini = "gpt-5.4-mini",
    Gpt54Nano = "gpt-5.4-nano",
    Gpt56Luna = "gpt-5.6-luna",
    Gpt56Terra = "gpt-5.6-terra",
    Gpt6Sol = "gpt-6-sol",
    Gpt6Luna = "gpt-6-luna",
    Gpt61Sol = "gpt-6.1-sol",
}

export class AiModelPricing {
    public modelName!: AiModel;
    public costPerMillionInputTokens!: number;
    public costPerMillionCachedTokens!: number;
    public costPerMillionOutputTokens!: number;
    public costPerMillionReasoningTokens!: number;
}

export const AiModelPricingByModelName: Record<AiModel, AiModelPricing> = {
    [AiModel.Gpt5Mini]: {
        modelName: AiModel.Gpt5Mini,
        costPerMillionInputTokens: 0.25,
        costPerMillionCachedTokens: 0.025,
        costPerMillionOutputTokens: 2.0,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt52]: {
        modelName: AiModel.Gpt52,
        costPerMillionInputTokens: 1.75,
        costPerMillionCachedTokens: 0.175,
        costPerMillionOutputTokens: 14.0,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt54Mini]: {
        modelName: AiModel.Gpt54Mini,
        costPerMillionInputTokens: 0.75,
        costPerMillionCachedTokens: 0.075,
        costPerMillionOutputTokens: 4.5,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt54Nano]: {
        modelName: AiModel.Gpt54Nano,
        costPerMillionInputTokens: 0.2,
        costPerMillionCachedTokens: 0.02,
        costPerMillionOutputTokens: 1.25,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt56Luna]: {
        modelName: AiModel.Gpt56Luna,
        costPerMillionInputTokens: 1.0,
        costPerMillionCachedTokens: 0.1,
        costPerMillionOutputTokens: 6.0,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt56Terra]: {
        modelName: AiModel.Gpt56Terra,
        costPerMillionInputTokens: 2.5,
        costPerMillionCachedTokens: 0.25,
        costPerMillionOutputTokens: 15.0,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt6Sol]: {
        modelName: AiModel.Gpt6Sol,
        costPerMillionInputTokens: 2.0,
        costPerMillionCachedTokens: 0.2,
        costPerMillionOutputTokens: 10.0,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt6Luna]: {
        modelName: AiModel.Gpt6Luna,
        costPerMillionInputTokens: 0.1,
        costPerMillionCachedTokens: 0.01,
        costPerMillionOutputTokens: 0.5,
        costPerMillionReasoningTokens: 0,
    },
    [AiModel.Gpt61Sol]: {
        modelName: AiModel.Gpt61Sol,
        costPerMillionInputTokens: 2.0,
        costPerMillionCachedTokens: 0.1,
        costPerMillionOutputTokens: 10.0,
        costPerMillionReasoningTokens: 0,
    },
};
